import axios from "axios";
import { authHeader } from "../../../header";


export async function getDeleteRequests() {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/auth/admin/request-centre/my-queue/delete-account-requests`,
      { headers: authHeader() }
    );
    console.log(response.data); // log only data
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; // rethrow so fetchDeleteRequests can catch
  }
}
